import { render } from "./SaveButtons.vue?vue&type=template&id=371cf6a1&scoped=true"
import script from "./SaveButtons.vue?vue&type=script&lang=js"
export * from "./SaveButtons.vue?vue&type=script&lang=js"

import "./SaveButtons.vue?vue&type=style&index=0&id=371cf6a1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-371cf6a1"]])

export default __exports__